export const test = '';

export const getUserName = (state) => state.auth.user.userName;
